// extracted by mini-css-extract-plugin
module.exports = {"likePost":"LikePost_likePost__U_5Fo","liked":"LikePost_liked__Vud_v"};